import React from 'react';

import { Route as CreditFacilitiesListRoute } from '~/core/routes/credit-facilities/_index';

export const BorrowerHomeRoute = () => <CreditFacilitiesListRoute />;
